import React, { useState } from 'react';

import { Form, Formik } from 'formik';
import { useToasts } from 'react-toast-notifications';

import Button from '@components/common/Button/Button';
import Select from '@components/common/Dropdowns/Select/Select';
import Checkbox from '@components/common/Formik/FormikCheckBox';
import Input from '@components/common/Formik/FormikInputField';
import useTranslateLpc from '@components/common/hooks/useTranslateLpc';
import { emailReminderModel } from '@models/PotModel/EmailReminderModel';
import PotService from '@services/domain/Lpc/PotService';

import css from './Message.module.scss';

type InvitationFormProps = {
    setActiveTab: (number) => void;
    emailList: string[];
    potRef: string;
};

const Invitation = ({ setActiveTab, emailList, potRef }: InvitationFormProps) => {
    const { t } = useTranslateLpc(['lpc-pot', 'common']);
    const { addToast } = useToasts();

    const [isLoading, setIsLoading] = useState(false);
    const [reminder, setReminder] = useState('3');

    const getInitialValues = () => {
        return {
            message: '',
            checkboxReminder: true,
        };
    };

    const onSubmit = (values) => {
        let body;

        if (values.checkboxReminder) {
            body = {
                message: values.message,
                emails: emailList,
                reminder: reminder,
            };
        } else {
            body = {
                message: values.message,
                emails: emailList,
            };
        }

        setIsLoading(true);
        PotService.sendInvites(potRef, body)
            .then((res) => res.status === 200 && setActiveTab(2))
            .catch((err) =>
                addToast(t(`errors.${err.code}`), {
                    appearance: 'error',
                    autoDismiss: true,
                }),
            )
            .finally(() => setIsLoading(false));
    };

    return (
        <Formik initialValues={getInitialValues()} onSubmit={(values) => onSubmit(values)}>
            {({ values }) => (
                <Form>
                    <>
                        <div className={css.form__input__message}>
                            <Input
                                name="message"
                                type="textarea"
                                label={t('invitation.message-label')}
                                placeholder={t('invitation.message-placeholder')}
                                isFloatingLabel
                            />
                            <div className={css.form__input__reminder}>
                                <Checkbox name="checkboxReminder">{t('invitation.reminder-label')} </Checkbox>

                                {values.checkboxReminder && (
                                    <Select
                                        options={emailReminderModel.map((item) => {
                                            return {
                                                value: item.value,
                                                label: t(`invitation.reminder-days.${item.value}`),
                                            };
                                        })}
                                        onSelect={(value) => setReminder(value)}
                                        customSelect={css.form__input__reminder__select}
                                        customMenu={css.form__input__reminder__select__menu}
                                        customControl={css.form__input__reminder__select__control}
                                        value={values.checkboxReminder ? reminder : null}
                                    />
                                )}
                            </div>
                        </div>
                        {/* SUBMIT */}
                        <div className={css.form__submit}>
                            <Button
                                type={'button'}
                                customClass={css.form__submit__cta}
                                variant={'secondary'}
                                onClick={() => setActiveTab(0)}
                            >
                                {t('invitation.previous')}
                            </Button>
                            <Button
                                type={'submit'}
                                margin={'0 0 0 8px'}
                                variant={'primary'}
                                customClass={css.form__submit__cta}
                                isLoading={isLoading}
                                isDisabled={isLoading}
                            >
                                {t('invitation.confirm')}
                            </Button>
                        </div>
                    </>
                </Form>
            )}
        </Formik>
    );
};
export default Invitation;
